import {
  put,
  call,
  take,
  takeLatest,
  select,
  takeEvery,
  cancel,
} from 'redux-saga/effects';
import get from 'lodash/get';
import findIndex from 'lodash/findIndex';

import { consts as upcomingSurveyCancelFillingConsts } from '../upcoming-survey-cancel-filling';
import { consts as upcomingSurveyCompletionsConsts } from '../upcoming-survey-completions';
import { consts as upcomingSurveyProceedConsts } from '../upcoming-survey-proceed';
import { consts as upcomingSurveyAnswersConsts } from '../upcoming-survey-answers';
import { consts as upcomingSurveyConsts } from '../upcoming-survey';
import { consts as answeredConsts } from '../answered';
import { consts as upcomingConsts, paginatedConsts } from '../upcoming';
import { consts as popupConsts, actions as popupActions } from '../../ui/popup';
import { UI_POPUP_TYPES } from '../../../constants/props';
import {
  selectUpcomingSurvey,
  selectUpcomingSurveyAssignmentId,
} from '../selectors';
import {
  loggedUserIdSelector,
  targetUserIdSelector,
} from '../../context/selectors';
import { currentLocationSelector } from '../../common/selectors';
import { HEALTHBOARD } from '../../../constants/routes';

function* upcomingSurveyProceedSucceedWorker({ payload }) {
  const meta = yield take(upcomingSurveyProceedConsts.ADD_META);
  yield put({
    type: upcomingSurveyConsts.SUCCEED,
    payload: { ...payload, meta: get(meta, 'payload') },
  });
  yield put({
    type: upcomingConsts.UPDATE_ITEM,
    payload,
  });
}

function* upcomingSurveyCancelFillingSucceedWorker({ payload }) {
  yield put({
    type: upcomingConsts.UPDATE_ITEM,
    payload,
  });
}

function* upcomingSurveyProceedRejectedWorker({ payload }) {
  const isStarted = get(payload, 'error.code') === 'already_started';

  const messageId = isStarted
    ? 'surveys.isStartedMessage'
    : 'surveys.inProgressMessage';
  const titleId = isStarted ? 'surveys.isStarted' : 'surveys.inProgress';

  yield put({
    type: popupConsts.SHOW,
    payload: {
      contentType: UI_POPUP_TYPES.MESSAGE,
      contentOptions: {
        message: { id: messageId },
        title: { id: titleId },
      },
    },
  });
}

function* upcomingSurveyAnswersWorker({ payload }) {
  const meta = yield take(upcomingSurveyAnswersConsts.ADD_META);
  const upcomingSurvey = yield select(selectUpcomingSurvey);

  const answers = get(upcomingSurvey, 'answers', []);
  const answerIndex = findIndex(answers, item => item.id === payload.id);

  const updatedAnswers = [...answers];

  if (answerIndex !== -1) updatedAnswers.splice(answerIndex, 1, payload);
  else updatedAnswers.push(payload);

  const updatedSurvey = {
    ...upcomingSurvey,
    answers: updatedAnswers,
    meta: get(meta, 'payload'),
    status: get(meta, 'payload.status'),
  };

  yield put({
    type: upcomingSurveyConsts.SUCCEED,
    payload: updatedSurvey,
  });
  yield put({
    type: upcomingConsts.UPDATE_ITEM,
    payload: updatedSurvey,
  });
}

function* finishingSurvey({
  payload: { token, statusSurvey, assignmentId, withAnswer },
}) {
  if (withAnswer) {
    yield take(upcomingSurveyAnswersConsts.SUCCEED);
  }

  yield put({
    type: upcomingSurveyCompletionsConsts.SEND,
    payload: {
      token,
      assignmentId,
      status: statusSurvey,
    },
  });
}

function* showScoreDescription(scoreRangeDescription) {
  yield put(
    popupActions.show({
      contentType: UI_POPUP_TYPES.MESSAGE,
      contentOptions: {
        icon: 'information',
        message: scoreRangeDescription,
        buttonTitle: { id: 'submit.expiredToken' },
      },
    }),
  );

  yield take(popupConsts.HIDE);
}

function* upcomingSurveyCompletionsWorker({ payload }) {
  const location = yield select(currentLocationSelector);
  const message = get(payload, 'survey.responseMessage');
  const scoreRangeDescription = get(
    payload,
    'scoreRangeDescription.description',
    null,
  );
  const assignmentId = yield select(selectUpcomingSurveyAssignmentId);
  const targetUserId = yield select(targetUserIdSelector);
  const loggedUserId = yield select(loggedUserIdSelector);
  const safeUserId = targetUserId || loggedUserId;

  if (location.includes(HEALTHBOARD)) {
    yield put({ type: upcomingSurveyConsts.CLEAR });
    if (scoreRangeDescription) {
      yield call(showScoreDescription, scoreRangeDescription);
    }
    yield cancel();
  }

  yield put({
    type: upcomingConsts.REMOVE_ITEMS,
    payload: [assignmentId],
  });
  yield put({
    type: upcomingSurveyConsts.CLEAR,
  });
  if (scoreRangeDescription) {
    yield call(showScoreDescription, scoreRangeDescription);
  } else {
    yield put({
      type: upcomingSurveyCompletionsConsts.MESSAGE,
      payload: message,
    });
  }
  yield put({
    type: paginatedConsts.LOAD_NEXT_REQUESTS,
    payload: { id: safeUserId, limit: 1 },
  });
  yield put({
    type: answeredConsts.SEND,
    payload: { id: safeUserId },
  });
}

export default function* upcomingSurveyProceedSaga() {
  yield takeLatest(
    upcomingSurveyProceedConsts.SUCCEED,
    upcomingSurveyProceedSucceedWorker,
  );
  yield takeLatest(
    upcomingSurveyCancelFillingConsts.SUCCEED,
    upcomingSurveyCancelFillingSucceedWorker,
  );
  yield takeLatest(
    upcomingSurveyProceedConsts.REJECTED,
    upcomingSurveyProceedRejectedWorker,
  );
  yield takeLatest(
    upcomingSurveyAnswersConsts.SUCCEED,
    upcomingSurveyAnswersWorker,
  );
  yield takeEvery(
    [
      upcomingSurveyCompletionsConsts.SUCCEED,
      upcomingSurveyCompletionsConsts.REJECTED,
    ],
    upcomingSurveyCompletionsWorker,
  );
  yield takeEvery(upcomingSurveyConsts.FINISH, finishingSurvey);
}



// WEBPACK FOOTER //
// ./src/redux/surveys/sagas/sequential-survey-saga.js